var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { FormattedDate, FormattedMessage, FormattedTime, injectIntl } from 'react-intl';
import { Container, Form, Card, CardBody, Row, Col, Input, CardFooter } from 'reactstrap';
import { ApplicationContext } from '../../../ApplicationContext';
import GetOrganisationAssetsCommand from '../../../commands/assets/GetOrganisationAssetsCommand';
import DeleteAssetAliasCommand from '../../../commands/assets/DeleteAssetAliasCommand';
import { FormErrorContext } from '../../../FormErrorContext';
import Signals from '../../../signals/Signals';
import { notifyUncaughtErrors, createErrorResponse } from '../../../utils/errorUtils';
import BasicFormGroup from '../../components/ui/BasicFormGroup/BasicFormGroup';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import UpdateDeviceOperatingHoursCommand from '../../../commands/devices/UpdateDeviceOperatingHoursCommand';
import { parseFloatToDecimals } from "../../../utils/numberUtils";
import { EmissionClassSelector } from "../../components/ui/EmissionClassSelector";
import { FuelTypeSelector } from "../../components/ui/FuelTypeSelector";
import { updateAsset } from '../../../requests/asset/updateAsset';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var UpdateAssetOverlay = /** @class */ (function (_super) {
    __extends(UpdateAssetOverlay, _super);
    function UpdateAssetOverlay(props) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, props) || this;
        var assetHasAlias = false;
        _this.state = {
            errors: [],
            submitting: false,
            assetModel: _this.props.assetModel,
            assetHasAlias: assetHasAlias,
            alias: (_b = (_a = _this.props.assetModel.properties) === null || _a === void 0 ? void 0 : _a.alias) !== null && _b !== void 0 ? _b : "",
            aliasHasChanged: false,
            newCumulativeOperatingHoursValue: null,
            emissionClass: _this.props.assetModel.emissionClass,
            nominalPower: _this.props.assetModel.nominalPower,
            fuelType: _this.props.assetModel.fuelType,
            emissionClassHasChanged: false,
            nominalPowerHasChanged: false,
            fuelTypeHasChanged: false,
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        _this.clear = _this.clear.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        return _this;
    }
    Object.defineProperty(UpdateAssetOverlay.prototype, "canEditOperatingHours", {
        get: function () {
            var assetModel = this.state.assetModel;
            return assetModel.isManualAssetWithAttachedDevice;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     */
    UpdateAssetOverlay.prototype.componentDidMount = function () {
        var _a, _b, _c;
        var assetModel = this.props.assetModel;
        var assetHasAlias = this.props.assetHasAlias;
        if (((_a = this.props.assetModel.properties.alias) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            assetHasAlias = true;
        }
        this.setState({
            assetModel: assetModel,
            assetHasAlias: assetHasAlias,
            alias: (_c = (_b = assetModel.properties) === null || _b === void 0 ? void 0 : _b.alias) !== null && _c !== void 0 ? _c : "",
            aliasHasChanged: false,
            newCumulativeOperatingHoursValue: null,
            emissionClass: assetModel.emissionClass,
            nominalPower: assetModel.nominalPower,
            fuelType: assetModel.fuelType,
            emissionClassHasChanged: false,
            nominalPowerHasChanged: false,
            fuelTypeHasChanged: false,
        });
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    UpdateAssetOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    UpdateAssetOverlay.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, className = _b.className, intl = _b.intl;
        var _c = this.state, errors = _c.errors, assetModel = _c.assetModel, alias = _c.alias, newCumulativeOperatingHoursValue = _c.newCumulativeOperatingHoursValue, aliasHasChanged = _c.aliasHasChanged, emissionClass = _c.emissionClass, nominalPower = _c.nominalPower, fuelType = _c.fuelType;
        return React.createElement(Container, { className: 'update-asset-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'asset.update.overlay.title' }, assetModel.properties) }),
                        React.createElement(CardBody, { className: 'd-flex' },
                            React.createElement(Col, null,
                                React.createElement(Row, null,
                                    React.createElement(Col, null,
                                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'asset.create.overlay.field.alias' }), htmlFor: "alias" },
                                            React.createElement("div", { className: 'input-group input-group-lg  input-group-merge' },
                                                React.createElement(Input, { type: "text", id: "alias", name: "alias", className: 'form-control form-control-appended', value: alias }),
                                                React.createElement("div", { className: 'input-group-append' },
                                                    React.createElement("div", { className: 'input-group-text' }, alias && alias.length > 0 ?
                                                        React.createElement("span", { className: "fe fe-x cursor-pointer small", onClick: this.clear }) : null)))))),
                                React.createElement(Row, null,
                                    React.createElement(Col, null,
                                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'asset.create.overlay.field.serialnumber' }), htmlFor: "serialNumber" },
                                            React.createElement(Input, { type: "text", id: "serialNumber", name: "serialNumber", required: true, disabled: true, value: assetModel.properties.serialNumber })))),
                                React.createElement(Row, null,
                                    React.createElement(Col, null,
                                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'asset.create.overlay.field.equipmentid' }), htmlFor: "equipmentId" },
                                            React.createElement(Input, { type: "text", id: "equipmentId", name: "equipmentId", disabled: true, value: assetModel.properties.equipmentId })))),
                                React.createElement(Row, null,
                                    React.createElement(Col, null,
                                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'asset.create.overlay.field.make' }), htmlFor: "make" },
                                            React.createElement(Input, { type: "text", id: "make", name: "make", required: true, disabled: true, value: assetModel.properties.make })))),
                                React.createElement(Row, null,
                                    React.createElement(Col, null,
                                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'asset.create.overlay.field.model' }), htmlFor: "model" },
                                            React.createElement(Input, { type: "text", id: "model", name: "model", required: true, disabled: true, value: assetModel.properties.model })))),
                                this.canEditOperatingHours && React.createElement(Row, null,
                                    React.createElement(Col, null,
                                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.device.update.overlay.field.operatinghours' }), htmlFor: "cumulativeOperatingHoursValue" },
                                            React.createElement(Input, { type: "number", min: 0, step: 0.1, id: "cumulativeOperatingHoursValue", name: "cumulativeOperatingHoursValue", placeholder: intl.formatMessage({ id: 'manual.asset.device.update.overlay.no.update' }) }),
                                            React.createElement("span", { className: "small text-muted d-block" },
                                                intl.formatMessage({ id: 'manual.asset.device.update.overlay.field.last.known.operatinghours' }, { value: ((_a = assetModel.cumulativeOperatingHoursDurationInHours) !== null && _a !== void 0 ? _a : 0).toLocaleString(undefined, { maximumFractionDigits: 1 }) }),
                                                React.createElement(FormattedDate, { value: assetModel.cumulativeOperatingHoursDateTime }),
                                                " ",
                                                React.createElement(FormattedTime, { value: assetModel.cumulativeOperatingHoursDateTime }))))),
                                React.createElement(Row, null,
                                    React.createElement(Col, null,
                                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.emissionClass' }), htmlFor: "emissionClass" },
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement(EmissionClassSelector, { value: emissionClass, onChange: function (value) {
                                                        _this.setState({ emissionClass: value, emissionClassHasChanged: true });
                                                    }, id: "emissionClass", name: "emissionClass", className: "w-100" }))),
                                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.nominalPower' }), htmlFor: "nominalPower" },
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement(Input, { type: "number", min: 0.1, step: 0.1, max: 10000, id: "nominalPower", name: "nominalPower", value: nominalPower !== null && nominalPower !== void 0 ? nominalPower : '', onChange: function (ev) {
                                                        _this.setState({ nominalPower: parseFloat(ev.target.value), nominalPowerHasChanged: true });
                                                    } }))),
                                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.fuelType' }), htmlFor: "fuelType" },
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement(FuelTypeSelector, { value: fuelType, onChange: function (value) {
                                                        _this.setState({ fuelType: value, fuelTypeHasChanged: true });
                                                    }, id: "fuelType", name: "fuelType", className: "w-100" }))))))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.labels.save" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     * @param event
     */
    UpdateAssetOverlay.prototype.deleteAlias = function () {
        var session = this.context.session;
        var intl = this.props.intl;
        var assetModel = this.state.assetModel;
        var command = new DeleteAssetAliasCommand();
        command.execute(assetModel, session.user.organisation.id, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     * @param event
     */
    UpdateAssetOverlay.prototype.onInputChange = function (event) {
        switch (event.target.name) {
            case 'cumulativeOperatingHoursValue':
                this.setState({ newCumulativeOperatingHoursValue: parseFloatToDecimals(event.target.value, 1) });
                break;
            case 'alias':
                this.setState({ aliasHasChanged: true, alias: event.target.value });
                break;
        }
    };
    /**
     * clears the alias input field.
     */
    UpdateAssetOverlay.prototype.clear = function () {
        this.setState({ alias: "", aliasHasChanged: true });
    };
    /**
     *
     * @param event
     */
    UpdateAssetOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var intl = this.props.intl;
        var _a = this.state, assetModel = _a.assetModel, assetHasAlias = _a.assetHasAlias, alias = _a.alias, aliasHasChanged = _a.aliasHasChanged, newCumulativeOperatingHoursValue = _a.newCumulativeOperatingHoursValue;
        var promises = [];
        assetModel.properties.alias = alias;
        if (this.state.aliasHasChanged
            || this.state.fuelTypeHasChanged
            || this.state.emissionClassHasChanged
            || this.state.nominalPowerHasChanged) {
            promises.push(updateAsset({
                alias: this.state.alias,
                emissionClass: this.state.emissionClass,
                nominalPower: this.state.nominalPower,
                fuelType: this.state.fuelType
            }, session.user.organisation.id, assetModel.getMetricsDbId()));
        }
        if (newCumulativeOperatingHoursValue != null) {
            //TODO update only device that is configured to update operating hours
            for (var device in assetModel.devices) {
                var command = new UpdateDeviceOperatingHoursCommand();
                promises.push(command.execute(assetModel.devices[device], newCumulativeOperatingHoursValue, session.user.organisation.id));
            }
        }
        Promise.all(promises).then(this.onSuccess).catch(this.onError);
    };
    /**
     *
     */
    UpdateAssetOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     */
    UpdateAssetOverlay.prototype.onSuccess = function (result) {
        this.setState({ errors: null, submitting: true });
        Signals.HideOverlay.dispatch();
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection;
        var user = session.user;
        var intl = this.props.intl;
        Signals.ShowNotification.dispatch(this.props.intl.formatMessage({ id: 'notification.asset.updated' }, Object(this.state.assetModel.properties)), 'dark', true);
        // Refresh assets
        var command = new GetOrganisationAssetsCommand();
        // Do show feedback to the user that getting the assets failed, so the user knows the overview is not the latest overview
        // No need for a .then() since the observer will pick up the changes in the asset collection
        command.execute(user.organisation, assetCollection).catch(function () {
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "error.assets.getcommand" }), 'danger', true);
        });
    };
    /**
     *
     * @param error
     */
    UpdateAssetOverlay.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    UpdateAssetOverlay.defaultProps = {
        className: ''
    };
    return UpdateAssetOverlay;
}(React.Component));
UpdateAssetOverlay.contextType = ApplicationContext;
export default injectIntl(UpdateAssetOverlay);
function computed(target, propertyKey, descriptor) {
    throw new Error('Function not implemented.');
}
